module.exports = __webpack_public_path__ + "img/linktree.d7d5b3ee.svg";